import { _ep0, _mw1, command } from "../commandBuilder";
import { CompleteMultipartUpload$ } from "../schemas/schemas_0";
export class CompleteMultipartUploadCommand extends command(_ep0, _mw1, "CompleteMultipartUpload", CompleteMultipartUpload$) {
}
